import React from 'react'

const Form = (props) => {
    return (
        <form>
            <div className="inputs">
                <div className="row">
                    <div className="form-label">
                        <label>Current Password</label>
                    </div>
                    <div className="form-input">
                        <input type="password" name="currentPassword" value={props.changePassword.currentPassword} onChange={props.onChange} />
                        <span className="error">{props.errors.currentPassword}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>New Password</label>
                    </div>
                    <div className="form-input">
                        <input type="password" name="newPassword" value={props.changePassword.newPassword} onChange={props.onChange} />
                        <span className="error">{props.errors.newPassword}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="form-label">
                        <label>Confirm New Password</label>
                    </div>
                    <div className="form-input">
                        <input type="password" name="confirmNewPassword" value={props.changePassword.confirmNewPassword} onChange={props.onChange} />
                        <span className="error">{props.errors.confirmNewPassword}</span>
                    </div>
                </div>
            </div>
            <div className="actions">
                <button type="reset" onClick={props.onCancel}>Cancel</button>
                <button type="submit" onClick={props.onSubmit}>Save</button>
            </div>
        </form>
    )
}

export default Form